<template>
  <edit-modal
    caption="Rij bewerken of toevoegen"
    :isActive="isActive">

    <column-select
      v-for="(column, idx) in staticColumns"
      :key="column.column.id"
      :column="column"
      :selected="getSelected(idx)"
      @update="update"
      @remove="remove(column.column.id)">
    </column-select>

    <save-buttons
      @save="save()"
      @cancel="close">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import ColumnSelect from '@/components/columns/ColumnSelect'

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    datasetId: {
      type: Number,
      default: null
    },
    duplicate: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EditModal,
    SaveButtons,
    ColumnSelect
  },
  data () {
    return {
      changes: []
    }
  },
  computed: {
    ...mapGetters({
      columns: 'columns/columns',
      dataset: 'datasets/dataset',
      datasets: 'datasets/datasets'
    }),
    staticColumns () {
      return this.columns.filter(x => !x.column.dynColumn)
    }
  },
  watch: {
    datasetId () {
      if (this.datasetId) {
        this.changes = []
        const dataset = this.datasets.find(x => x.id === this.datasetId)

        if (this.duplicate) {
          const columnIds = this.columns.map(c => c.column.id)

          dataset.columns.filter(column => columnIds.includes(column.id)).forEach(column => {
            if (column.value.id) {
              this.changes.push({
                column_id: column.id,
                value_id: column.value.id
              })
            }
          })
        }

        this.$store.commit('datasets/SET', dataset)
      }
    },
    isActive () {
      if (!this.isActive) this.$store.commit('datasets/SET', null)
    }
  },
  methods: {
    getSelected (idx) {
      return (this.dataset) ? this.dataset.columns[idx].value.id : null
    },
    save () {
      this.$emit('save', {
        id: (this.duplicate) ? null : this.datasetId,
        data: this.changes
      })

      this.close()
    },
    update (payload) {
      const idx = this.changes.findIndex(x => x.column_id === payload.column_id)

      if (idx !== -1) {
        this.changes[idx].value_id = payload.value_id
      } else {
        this.changes.push(payload)
      }
    },
    remove (columnId) {
      const idx = this.changes.findIndex(x => x.column_id === columnId)

      if (idx !== -1) {
        this.changes[idx].value_id = null
      } else {
        this.changes.push({
          column_id: columnId,
          value_id: null
        })
      }
    },
    close () {
      if (this.duplicate || this.datasetId) this.changes = []

      this.$emit('close')
    },
    getValue (columnId, valueId) {
      return this.columns.find(x => x.column.id === columnId).values.find(x => x.id === valueId)
    },
    getValues (columns) {
      return columns.map((column) => {
        return {
          column_id: column.id,
          value_id: column.values.find(x => x.column_id === column.id)
        }
      })
    }
  }
}
</script>
